export enum FieldType {
    TEXT = "TEXT",
    DATE = "DATE",
    BOOLEAN = "BOOLEAN",
    TIME = "TIME",
    NUMBER = "NUMBER",
    SELECT = "SELECT",
    MULTIPLE_SELECT = "MULTIPLE_SELECT"
  }
  
  export interface EventField {
    uid: string;
    name: string;
    eventTypeId: number;
    eventTypeUid: string;
    displayName: string;
    fieldType: FieldType;
    mandatory: boolean;
    positionOrder: number;
    options: string[];
  }